type Unsub = () => void

interface Registry {
  jobUnsub: Unsub | null
  routeControls: Record<string, any>   // vehicle name -> L.Routing.Control
  drawLayer: any | null                // L.FeatureGroup for leaflet-draw
}

const state: Registry = { jobUnsub: null, routeControls: {}, drawLayer: null }

export const optimizerRegistry = {
  startJob(unsub: Unsub): void {
    if (state.jobUnsub) { try { state.jobUnsub() } catch { /* ignore */ } }
    state.jobUnsub = unsub
  },
  stopJob(): void {
    if (state.jobUnsub) { try { state.jobUnsub() } catch { /* ignore */ } state.jobUnsub = null }
  },
  setRouteControl(vehicle: string, control: any): void { state.routeControls[vehicle] = control },
  getRouteControl(vehicle: string): any | undefined { return state.routeControls[vehicle] },
  clearRouteControls(): Record<string, any> { const c = state.routeControls; state.routeControls = {}; return c },
  setDrawLayer(layer: any): void { state.drawLayer = layer },
  getDrawLayer(): any | null { return state.drawLayer },
}
